import React, { useRef } from "react";
import "./modal-client.scss";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "../../../components/modal-components/dialog-title";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import { useDispatch, useSelector } from "react-redux";
import { savePhotoOffice, deleteMedia } from "../../../store/actions/selects";
import CloseIcon from "@material-ui/icons/Close";
import { NewDate } from "../../../components/history-list/history-list";
import { CircularIndeterminate } from "../pages/training-client/training-client";
import { deleteFileAdmin, saveFileAdmin } from "../../../store/actions/client";

const SaveDocument = (props) => {
  const { open, setOpen, child, client_id } = props;
  const loading = useSelector((state) => state.auth.loading);
  const dispatch = useDispatch();
  const collection = "Children.docs";
  const hiddenFileInput = useRef(null);

  console.log(props);

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const deleteDocs = (id) => {
    if (client_id) {
      dispatch(deleteFileAdmin(collection, child.id, id, client_id));
    } else dispatch(deleteMedia(collection, child.id, id));
  };

  const fileHandler = (event) => {
    const { files } = event.target;
    if (client_id) {
      dispatch(saveFileAdmin(files[0], collection, child.id, client_id));
    } else dispatch(savePhotoOffice(files[0], collection, child.id));
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="form-dialog"
      fullWidth
      maxWidth={"xs"}
      PaperProps={{
        style: {
          boxShadow: "none",
          width: "95%",
          margin: 0,
        },
      }}
    >
      <DialogTitle id="form-dialog-paid">Документы</DialogTitle>
      <DialogContent id="childDocumentContent">
        {loading ? (
          <CircularIndeterminate />
        ) : (
          <div className="childDocumentsContainer">
            {child.documents?.length > 0 ? (
              child.documents.map((item, index) => (
                <div key={item.id} className="childDocuments">
                  <NewDate
                    created_at={item.created_at}
                    className="childDocumentsDate"
                  />
                  <a
                    href={item.full_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Документ {index + 1}
                  </a>
                  <CloseIcon onClick={() => deleteDocs(item.id)} />
                </div>
              ))
            ) : (
              <span>Нет документов</span>
            )}
          </div>
        )}
        <Button onClick={handleClick}>Загрузить скан</Button>
        <input
          type="file"
          onChange={fileHandler}
          ref={hiddenFileInput}
          style={{ display: "none" }}
        />
      </DialogContent>
      <DialogActions id="childDocumentContentBtn">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setOpen(!open);
          }}
        >
          Ок
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveDocument;
